<div class="w-full max-w-[800px] p-0">

  <!-- Header -->
  <div style="display: flex; align-items: center; gap: 12px; padding: 20px 24px; border-bottom: 1px solid #e5e7eb;">
    <div style="background: #dcfce7; border-radius: 12px; padding: 10px; display: flex; align-items: center; justify-content: center;">
      <mat-icon style="color: #1C593D; font-size: 24px; width: 24px; height: 24px;">check_circle</mat-icon>
    </div>
    <div>
      <h2 style="margin: 0; font-size: 1.2rem; font-weight: 700; color: #111827;">Aprobar Swap</h2>
      <p style="margin: 2px 0 0 0; font-size: 0.8rem; color: #6b7280;">Confirmar aprobaci&oacute;n de transacci&oacute;n VES</p>
    </div>
  </div>

  <!-- Info card -->
  <div style="margin: 16px 24px; padding: 16px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px;">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">ID Transacci&oacute;n</span>
        <span style="color: #2563eb; font-weight: 700; font-size: 0.9rem; font-family: monospace;">#{{ transaction.id }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Referencia</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem; font-family: monospace;">{{ transaction.referenceId || '-' }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Usuario</span>
        <span style="color: #111827; font-weight: 600; font-size: 0.9rem;">{{ transaction.userName }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Email</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ transaction.userEmail }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Documento</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem; font-family: monospace;">{{ transaction.userIdType }} {{ transaction.userIdNumber }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Tipo</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ transaction.type }}</span>
      </div>
      <div *ngIf="transaction.usdtAmount">
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Monto USDT</span>
        <span style="color: #2563eb; font-weight: 700; font-size: 0.9rem;">{{ transaction.usdtAmount }} USDT</span>
      </div>
      <div *ngIf="transaction.vesRate">
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Tasa VES/USDT</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ transaction.vesRate }}</span>
      </div>
      <div *ngIf="transaction.banco">
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Banco</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ transaction.banco }}</span>
      </div>
      <div *ngIf="transaction.operador">
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Operador</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ transaction.operador }}</span>
      </div>

      <!-- Montos VES -->
      <div style="grid-column: 1 / -1; padding-top: 4px; border-top: 1px solid #bbf7d0;">
        <div class="flex gap-6">
          <div *ngIf="transaction.creditVes">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Cr&eacute;dito VES</span>
            <span style="color: #16a34a; font-weight: 700; font-size: 1.1rem;">{{ formatVES(transaction.creditVes) }}</span>
          </div>
          <div *ngIf="transaction.debitVes">
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">D&eacute;bito VES</span>
            <span style="color: #dc2626; font-weight: 700; font-size: 1.1rem;">{{ formatVES(transaction.debitVes) }}</span>
          </div>
          <div>
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Saldo VES</span>
            <span style="color: #1e5a3f; font-weight: 700; font-size: 1.1rem;">{{ formatVES(transaction.balanceVes) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Buttons -->
  <div style="display: flex; gap: 12px; padding: 20px 24px; border-top: 1px solid #e5e7eb; justify-content: flex-end;">
    <button (click)="close()"
      style="padding: 10px 24px; background: #f3f4f6; color: #374151; border: none; border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;">
      Cancelar
    </button>
    <button (click)="approveSwap()" [disabled]="loading"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: #1C593D; color: white; border: none; border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;"
      [style.opacity]="loading ? '0.5' : '1'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px;">check</mat-icon>
      Aprobar transacci&oacute;n
    </button>
  </div>

</div>
